module.exports = __webpack_public_path__ + "img/facebook-logo.30f2798f.svg";